(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["zardo-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zardo-countdown')) {
    customElements.define('zardo-countdown', class extends HTMLElement {
      connectedCallback() {
        this.end = Date.parse(this.dataset.end || '');
        this.units = {};
        this.querySelectorAll('[data-unit]').forEach((element) => {
          this.units[element.dataset.unit] = element;
        });
        this.status = this.querySelector('[data-countdown-status]');
        this.daysGroup = this.querySelector('[data-countdown-days]');
        this.expiredMessage = this.querySelector('[data-countdown-expired]');
        this.lastMinute = null;
        this.events = new AbortController();
        const { signal } = this.events;
        document.addEventListener('visibilitychange', () => this.update(), { signal });
        window.addEventListener('pageshow', () => this.update(), { signal });
        this.update();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.events?.abort();
      }

      update() {
        clearTimeout(this.timer);
        if (!Number.isFinite(this.end) || document.visibilityState === 'hidden') return;

        const remaining = this.end - Date.now();
        this.toggleAttribute('data-urgent', this.dataset.urgentWindow === '24' && remaining > 0 && remaining <= 24 * 60 * 60 * 1000);
        if (remaining <= 0) {
          this.expire();
          return;
        }

        const total = Math.floor(remaining / 1000);
        const parts = {
          days: Math.floor(total / 86400),
          hours: Math.floor((total % 86400) / 3600),
          minutes: Math.floor((total % 3600) / 60),
          seconds: total % 60,
        };
        const shown = { ...parts };
        if (!this.units.days) shown.hours += parts.days * 24;
        if (this.daysGroup) this.daysGroup.hidden = parts.days === 0;
        this.style.setProperty('--zardo-countdown-unit-count', Object.keys(this.units).length - (this.daysGroup?.hidden ? 1 : 0));

        Object.entries(this.units).forEach(([unit, element]) => {
          this.setValue(element, String(shown[unit]).padStart(2, '0'));
        });

        const minute = Math.floor(remaining / 60000);
        if (this.status && minute !== this.lastMinute) {
          this.lastMinute = minute;
          let template = this.dataset.status || '';
          if (parts.days === 0) template = template.replace(/\[days\][^,]*,\s*/, '');
          this.status.textContent = template
            .replace('[days]', parts.days)
            .replace('[hours]', parts.hours)
            .replace('[minutes]', parts.minutes);
        }

        const step = this.units.seconds ? 1000 : 60000;
        const delay = Math.min(remaining, step - (Date.now() % step)) + 20;
        this.timer = setTimeout(() => this.update(), delay);
      }

      setValue(element, value) {
        if (element.dataset.value === value) return;
        element.dataset.value = value;
        (element.firstElementChild || element).textContent = value;
      }

      expire() {
        Object.values(this.units).forEach((element) => this.setValue(element, '00'));
        if (this.daysGroup) this.daysGroup.hidden = true;
        this.style.setProperty('--zardo-countdown-unit-count', Object.keys(this.units).length - (this.daysGroup ? 1 : 0));
        this.toggleAttribute('data-expired', true);
        if (this.status) this.status.textContent = this.expiredMessage?.textContent.trim() || '';

        if (this.dataset.expiredMode === 'hide' && !window.Shopify?.designMode) {
          const section = this.closest('.shopify-section');
          if (section) section.style.display = 'none';
        }
      }
    });
  }

  if (!window.zardoCountdownKlaviyoBound) {
    window.zardoCountdownKlaviyoBound = true;

    const klaviyoReady = () => !!(window._klOnsite && typeof window._klOnsite.openForm === 'function');
    const openKlaviyo = (formId) => {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    };
    const openNotifyDialog = (dialogId) => {
      const dialog = dialogId ? document.getElementById(dialogId) : null;
      if (!dialog || typeof dialog.showModal !== 'function') return false;
      if (!dialog.open) dialog.showModal();
      const focusTarget = dialog.querySelector('[data-notify-success], input[type="email"]');
      if (focusTarget) focusTarget.focus();
      return true;
    };

    document.addEventListener('click', (event) => {
      const dialog = event.target.closest('dialog.zardo-countdown-notify');
      if (dialog && event.target === dialog) {
        dialog.close();
        return;
      }

      const trigger = event.target.closest('[data-zardo-klaviyo-form]');
      if (!trigger) return;
      const formId = trigger.dataset.zardoKlaviyoForm;
      const fallbackId = trigger.dataset.zardoNotifyFallback;
      if (!formId && !fallbackId) return;
      event.preventDefault();

      if (!fallbackId) {
        openKlaviyo(formId);
        return;
      }
      if (formId && klaviyoReady()) {
        openKlaviyo(formId);
        return;
      }

      // Klaviyo is not running yet: blocked by an ad blocker, or still loading.
      // Give it a short grace period, then fall back to the built-in Shopify form.
      const started = Date.now();
      const settle = () => {
        if (formId && klaviyoReady()) {
          openKlaviyo(formId);
          return;
        }
        if (Date.now() - started < 1500) {
          setTimeout(settle, 100);
          return;
        }
        openNotifyDialog(fallbackId);
      };
      settle();
    });

    // Shopify redirects back with the form id as the hash after a successful signup:
    // reopen that dialog so the visitor sees the confirmation.
    const hash = window.location.hash.slice(1);
    if (hash) {
      const dialog = document.querySelector(`dialog.zardo-countdown-notify[data-notify-form="${CSS.escape(hash)}"]`);
      if (dialog && dialog.querySelector('[data-notify-success]')) openNotifyDialog(dialog.id);
    }
  }

  if (!customElements.get('zardo-countdown-media')) {
    customElements.define('zardo-countdown-media', class extends HTMLElement {
      connectedCallback() {
        this.templates = {
          desktop: this.querySelector('template[data-media="desktop"]'),
          mobile: this.querySelector('template[data-media="mobile"]'),
        };
        if (!this.templates.desktop && !this.templates.mobile) return;

        this.current = null;
        this.events = new AbortController();
        const { signal } = this.events;
        this.mobileQuery = window.matchMedia('(max-width: 699px)');
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobileQuery.addEventListener('change', () => this.mount(), { signal });
        this.motionQuery.addEventListener('change', () => this.mount(), { signal });
        this.mount();
      }

      disconnectedCallback() {
        this.events?.abort();
      }

      mount() {
        let wanted = null;
        if (!this.motionQuery.matches) {
          if (this.mobileQuery.matches) {
            if (this.templates.mobile) wanted = 'mobile';
            else if (!this.hasAttribute('data-mobile-image') && this.templates.desktop) wanted = 'desktop';
          } else if (this.templates.desktop) {
            wanted = 'desktop';
          }
        }
        if (wanted === this.current) return;

        this.current = wanted;
        this.querySelector('video')?.remove();
        if (!wanted) return;

        const video = this.templates[wanted].content.firstElementChild.cloneNode(true);
        video.muted = true;
        this.append(video);
        const playing = video.play();
        if (playing) playing.catch(() => {});
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
